import React from 'react';
import { Field } from '../../../features/form';
import { FieldComponent, FormIcon } from './FieldForms';
import { Div } from '../../../components/grid';

const EanForm = () => (
  <Div marginTop="10px">
    <Field
      component={FieldComponent}
      icon={<FormIcon hashtag />}
      name="cvr"
      formKey="ean"
      type="text"
      placeholder="CVR(8 cifre)"
      required
    />
    <Field
      component={FieldComponent}
      icon={<FormIcon hashtag />}
      name="ean"
      formKey="ean"
      type="text"
      placeholder="EAN(13 cifre)"
      required
    />
    <Field
      component={FieldComponent}
      icon={<FormIcon hashtag />}
      name="eanReference"
      formKey="ean"
      type="text"
      placeholder="EAN Reference"
    />
  </Div>
);

export default EanForm;
